import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import useCareerPulseQuestions from 'components/Common/CareerPulseQuestions/Hooks/useCareerPulseQuestions';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Members/Profile/Actions';
import Modal from 'components/new_ui/Modal/Modal';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useNavigate } from 'react-router-dom';

export default function CareerHistory() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();
  const careerPulseQuestions = useCareerPulseQuestions();

  const [questions, setQuestion] = useState(null);
  const [initFormValues, setInitFormValues] = useState(null);
  const [formSchema, setFormSchema] = useState({});

  const navigate = useNavigate();

  const member = stateUsers.user.attributes.specific;

  useEffect(() => {
    if (careerPulseQuestions) {
      const formQuestions = careerPulseQuestions.filter((item) => item.attributes.name.includes('CUSTOM_CH_Q'));
      setQuestion(formQuestions);
      const formValues = {};
      const schema = {};
      formQuestions.forEach((item) => {
        formValues[item.attributes.name] = stateUsers.user.attributes.specific.career_histories
          .find((data) => data.code === item.attributes.name)?.answer_weight;

        schema[item.attributes.name] = Yup.number().required('Please, select Answer');
      });
      setInitFormValues(formValues);
      setFormSchema(schema);
    }
  }, [careerPulseQuestions]);

  const onSubmitHundler = (values, { setSubmitting }) => {
    Actions.updateCareerHistory(
      member.id,
      values,
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        navigate(-1);
      },
    );
  };

  return (
    <Modal size="lg" show>
      {questions === null && <LoadingPlaceholder text="Loading..." />}
      {questions !== null
      && (
      <Formik
        initialValues={initFormValues}
        validationSchema={Yup.object().shape(formSchema)}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">

            {questions.map((question) => (
              <Row>
                <Col>
                  <HorizontalSelectField
                    name={question.attributes.name}
                    label={question.attributes.title}
                    placeholder="Select Answer"
                    isClearable={false}
                    options={question.attributes.answers.map((el) => ({
                      label: el.title,
                      value: el.weightage,
                    }))}
                  />
                </Col>
              </Row>
            ))}

            <Footer loading={isSubmitting} onCancel={() => navigate(-1)} />
          </FormikForm>
        )}
      </Formik>
      )}
    </Modal>
  );
}
